function GoogleButton({ text }) {
  return (
    <div className="border-2 bg-white cursor-pointer mb-8 border-blue text-blue px-6 py-3.5 w-full max-w-[400px] flex items-center rounded-[15px]">
      <img src="/google.svg" alt="google" />
      <span className="font-medium 	text-sm sm:text-2xl md:text-base sm:ml-12 md::ml-1  lg:text-2xl mr-4 ml-1   lg:ml-12	">
        {text}
      </span>
    </div>
  );
}

export default GoogleButton;
